import { InfoIconTooltip } from '@ais-ui/ui-core';
import React, { useState } from 'react';
import { useLocalization } from '@ais-ui/locale-management';

import { VesselHoverLabels } from './VesselHoverLabels';
import { AtonHoverLabels } from './AtonHoverLabels';
import { BaseStationHoverLabels } from './BaseStationHoverLabels';
import { VirtualAtonHoverLabels } from './VirtualAtonHoverLabels';
import { MethydHoverLabels } from './MethydHoverLabels';
import { RadarHoverLabels } from './RadarHoverLabels';
import { DasHoverLabels } from './DasHoverLabels';
import { DroneHoverLabels } from './DroneHoverLabels';
import { UseFormReturn } from 'react-hook-form';
import { MapFormValues } from './useMapForm';
import { TargetHoverLabelTabs } from './TargetHoverLabelTabs';

interface TargetHoverLabelFormProps {
  form: UseFormReturn<MapFormValues>;
}

export type HoverLabelTargetType =
  | 'vessel'
  | 'aton'
  | 'virtualAton'
  | 'methyd'
  | 'baseStation'
  | 'radar'
  | 'das'
  | 'drone';

export function TargetHoverLabelForm({ form }: TargetHoverLabelFormProps) {
  const { messages } = useLocalization();

  const [tab, setTab] = useState<HoverLabelTargetType>('vessel');

  const getTitle = () => {
    switch (tab) {
      case 'baseStation':
        return messages.settingsMapBaseStationHoverTitle;
      case 'aton':
        return messages.settingsMapAtonHoverTitle;
      case 'virtualAton':
        return messages.settingsMapVirtualAtonHoverTitle;
      case 'methyd':
        return messages.settingsMapMethydHoverTitle;
      case 'radar':
        return messages.settingsMapRadarHoverTitle;
      case 'das':
        return 'DAS hover labels';
      case 'drone':
        return 'Drone hover labels';
      default:
        return messages.settingsMapVesselHoverTitle;
    }
  };

  return (
    <div className="space-y-4">
      <div className="flex justify-between">
        <div className={'flex items-center space-x-1'}>
          <h3 className="text-lg font-medium">{getTitle()}</h3>
          <InfoIconTooltip>
            {messages.settingsMapTargetInfoTooltip}
          </InfoIconTooltip>
        </div>
        <TargetHoverLabelTabs setTab={setTab} tab={tab} />
      </div>

      {tab === 'vessel' && <VesselHoverLabels form={form} />}
      {tab === 'aton' && <AtonHoverLabels form={form} />}
      {tab === 'virtualAton' && <VirtualAtonHoverLabels form={form} />}
      {tab === 'methyd' && <MethydHoverLabels form={form} />}
      {tab === 'baseStation' && <BaseStationHoverLabels form={form} />}
      {tab === 'radar' && <RadarHoverLabels form={form} />}
      {tab === 'das' && <DasHoverLabels form={form} />}
      {tab === 'drone' && <DroneHoverLabels form={form} />}
    </div>
  );
}
